import React, { useEffect, useState } from "react";
import axios from "axios";
import { FiDownload } from "react-icons/fi";

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";

const NewsLetter = () => {
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Styles CSS pour les animations du spinner
  React.useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      
      .spinner-ring:nth-child(1) {
        border-top-color: #4299e1;
        animation-delay: 0s;
      }
      
      .spinner-ring:nth-child(2) {
        border-right-color: #38b2ac;
        animation-delay: 0.5s;
      }
      
      .spinner-ring:nth-child(3) {
        border-bottom-color: #ed8936;
        animation-delay: 1s;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  // Charger tous les emails
  useEffect(() => {
    axios
      .get(`${apiUrl}/api/newsletter/all`)
      .then((res) => {
        setEmails(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setError("Erreur lors du chargement des emails.");
        setLoading(false);
      });
  }, []);

  // Fonction pour exporter
  const handleExport = () => {
    window.open(
      `${process.env.REACT_APP_API_URL}/api/newsletter/export`,
      "_blank"
    );
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Liste des abonnés à la newsletter</h2>

      {loading ? (
        <div style={styles.loadingContainer}>
          <div style={styles.modernSpinner}>
            <div style={styles.spinnerRing}></div>
            <div style={styles.spinnerRing}></div>
            <div style={styles.spinnerRing}></div>
          </div>
          <p style={styles.loadingText}>Chargement en cours...</p>
        </div>
      ) : error ? (
        <p style={styles.error}>{error}</p>
      ) : (
        <>
          <div style={styles.exportBar}>
            <p>{emails.length} email(s) inscrit(s)</p>
            <button onClick={handleExport} style={styles.exportButton}>
              <FiDownload style={{ marginRight: 8 }} />
              Exporter (.xlsx)
            </button>
          </div>

          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Email</th>
                <th style={styles.th}>Date d'inscription</th>
              </tr>
            </thead>
            <tbody>
              {emails.map((email, index) => (
                <tr key={index}>
                  <td style={styles.td}>{email.email}</td>
                  <td style={styles.td}>
                    {new Date(email.createdAt).toLocaleString("fr-FR")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

const styles = {
  container: {
    padding: "40px",
    fontFamily: "Georgia, serif",
    maxWidth: "900px",
    margin: "0 auto",
  },
  heading: {
    fontSize: "24px",
    marginBottom: "20px",
    textAlign: "center",
  },
  error: {
    color: "red",
    textAlign: "center",
  },
  exportBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  exportButton: {
    padding: "10px 20px",
    backgroundColor: "#000",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    border: "1px solid #ccc",
  },
  th: {
    backgroundColor: "#f5f5f5",
    padding: "12px",
    textAlign: "left",
    borderBottom: "1px solid #ccc",
  },
  td: {
    padding: "12px",
    borderBottom: "1px solid #eee",
  },
  // Spinner moderne et centré
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "3rem 0",
    minHeight: "200px",
  },
  modernSpinner: {
    position: "relative",
    width: "60px",
    height: "60px",
    marginBottom: "1rem",
  },
  spinnerRing: {
    position: "absolute",
    width: "100%",
    height: "100%",
    border: "3px solid transparent",
    borderRadius: "50%",
    animation: "spin 1.5s linear infinite",
  },
  loadingText: {
    color: "#4a5568",
    fontSize: "1rem",
    fontWeight: "500",
    margin: "0",
    textAlign: "center",
  },
};

export default NewsLetter;
